import state from './moduleCrewTimesheetState.js'
import mutations from './moduleCrewTimesheetMutations.js'
import actions from './moduleCrewTimesheetActions.js'
import getters from './moduleCrewTimesheetGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
